import { AxiosResponse } from "axios";
import { API_ROOT } from "services/baseURLs.config";
import { axiosRequest } from "./api.utils";
import type { BackendErrorPayload } from "./backendError";

export interface TaxTableLookup {
  errorCode: number;
  personalNumber: string | null;
  taxTable: number | null;
  errorMessage: string | null;
  taxForm: string | null;
}

export interface TaxTableLookupResponse {
  data: TaxTableLookup | null;
  error: BackendErrorPayload | null;
}

const getTaxTableByPersonalNumber = async ({
  companyId,
  personalNumber,
}: {
  companyId: number;
  personalNumber: string;
}): Promise<AxiosResponse<TaxTableLookupResponse>> => {
  return await axiosRequest.auth.post<TaxTableLookupResponse>(
    `${API_ROOT}/taxtable`,
    { companyId, personalNumber },
  );
};

export const taxTable = {
  getTaxTableByPersonalNumber,
};
